wbApp.controller('FormResponsesCtrl', ['$scope', '$modal', '$translate', '$filter', 'formResponseSvc', 'securitySvc', 'gridSortSvc',
function ($scope, $modal, $translate, $filter, formResponseSvc, securitySvc, gridSortSvc) {

    $scope.formsResponses = [];
    var selectedForm = null;

    var formId = null;

    function loadData(formId)
    {
        $scope.formsResponses = [];
        var all = formResponseSvc.getAllByFormId(formId);
        all.then(function (data) {
            $scope.formsResponses = data;
        }, function (error) {
            $scope.formsResponses = [];
        });
    }

    $scope.$on('formSelectionChanged', function (e, newlySelectedForm) {
        if (newlySelectedForm) {
            
            if ($scope.formsResponsesGridSettings.gridInstance) {
                $scope.formsResponsesGridSettings.gridInstance.columnOption('referenceNumber', 'visible', newlySelectedForm.formType === 1);
            }
            
            if (!selectedForm || (selectedForm.id !== newlySelectedForm.id)) {
                formId = newlySelectedForm.id;
                loadData(formId);
            }
        }
        else {
            $scope.formsResponses = [];
        }

        selectedForm = newlySelectedForm;
    });

    $scope.formsResponsesGridSettings = {
        name: 'formsResponses',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'number', visible: false },
            {
                showInColumnChooser: false,
                caption: '',
                dataField: 'isNotRegisteredUser',
                width: '42px',
                alignment: 'center',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: true, name: $translate.instant('TXT_ANONYMOUS_USER') },
                                { id: false, name: $translate.instant('TXT_REGISTERED_USER') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                encodeHtml: false,
                calculateSortValue: function (rowData) { return rowData.marker; },
                calculateDisplayValue: function (rowData) {
                    if (typeof rowData.isNotRegisteredUser === 'undefined' || rowData.isNotRegisteredUser === null) {
                        return "";
                    } else {
                        var icon = !!rowData.isNotRegisteredUser ? 'fa-user-o' : 'fa-user';
                        var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                        return res;
                    }
                },
            },
            {
                dataField: 'referenceNumber',
                name: 'referenceNumber',
                caption: $translate.instant('TXT_REFERENCE_NUMBER'), 
                dataType: 'string', 
                width: '50px',
                visible: false
            },            
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', width: '190px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'studentFullName') }
            },
            {
                dataField: 'userPhone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.userPhone);
                },
                width: '120px'
            },
            { dataField: 'userEmail', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px' },
            { dataField: 'studentBirthday', caption: $translate.instant("TXT_LBL_BIRTHDAY"), dataType: 'date', format: { date: 'short' }, width: '80px' },
            {
                dataField: 'userFullName', caption: $translate.instant('TXT_VAL_RCPG_USER'), dataType: 'string', width: '190px',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'userFullName') }
            },
            { dataField: 'primaryAnswer', caption: $translate.instant('TXT_LBL_YOUR_ANSWER'), dataType: 'string' },
            { dataField: 'createdAt', caption: $translate.instant("TXT_LBL_CREATED_AT"), dataType: 'date', sortOrder: 'desc', format: { type: 'shortDateShortTime' }, width: '120px' },
        ],
        onEditorPreparing: function (e) {
            if (e.parentType == 'filterRow' && e.dataField == 'isNotRegisteredUser') {
                e.editorOptions.itemTemplate = function (itemData, itemIndex, itemElement) {
                    if (itemIndex == 0) {
                        return $("<i class='fa fa-user-circle' aria-hidden='true'></i>");
                    } else {
                        var icon = itemIndex == 1 ? 'fa-user-o' : 'fa-user';
                        var res = "<i class='fa " + icon + "' aria-hidden='true'></i>";

                        return res;
                    }
                }
            }
        },
        shouldDisableAdd: function () { return !$scope.selectedForm },
        customCommands: [{
            text: $translate.instant('TXT_SHOW_PREVIEW'),
            isVisible: function () { return securitySvc.isInRole('FormsDefinitions') && !!selectedForm; },
            callback: function (data) { $scope.onShowFormPreview(data); }
        }, {
            text: $translate.instant('TXT_PRINT_CONTRACT_TEMPLATE'),
            isVisible: function () { return !!selectedForm && !String.prototype.isNullOrWhitespace(selectedForm.contractTemplateId); },
            callback: function (data) { $scope.onShowContractTemplate(data); }
        }]
    }

    $scope.onShowContractTemplate = function(responseInfo) {
        window.open("restapi/forms-responses/" + responseInfo.id + "/report", '_blank');
    }

    $scope.onShowFormPreview = function (responseInfo) {
        formPreviewPromise.$promise.then(function () {
            formPreviewPromise.$scope.formId = selectedForm.id;
            formPreviewPromise.$scope.formDefinitionRevision = selectedForm.auditEvent.revision !== responseInfo.formDefinitionRevision
                ? responseInfo.formDefinitionRevision
                : null;
            formPreviewPromise.$scope.formResponseId = responseInfo.id;
            formPreviewPromise.$scope.enableSave = true;
            formPreviewPromise.show();
        });
    }

    $scope.onAddResponse = function() {
        formPreviewPromise.$promise.then(function () {
            formPreviewPromise.$scope.formId = selectedForm.id;
            formPreviewPromise.$scope.formDefinitionRevision = null;
            formPreviewPromise.$scope.formResponseId = null;
            formPreviewPromise.$scope.enableSave = true;
            formPreviewPromise.$scope.formSaved = function () {
                loadData(formId);
            },
            formPreviewPromise.show();
        });
    }

    $scope.onDeleteResponse = function (data) {
        formResponseSvc.remove(data.id).$promise.then(function () {
            loadData(selectedForm.id);
        });
    }

    var formPreviewPromise = $modal({
        templateUrl: 'forms/forms-response-preview.html',
        show: false,
        scope: $scope.$new()
    });
}]);
